export class Subscription {
    constructor() {
        this._onChanges = [];
    }
    subscribe(onChange) {
        this.unSubscribe(onChange);
        this._onChanges.push(onChange);
    }
    unSubscribe(onChange) {
        let index = this._onChanges.indexOf(onChange);
        if (index > -1) {
            this._onChanges.splice(index, 1);
        }
    }
    hasSubcribers() {
        return this._onChanges.length > 0;
    }
    inform(type, data = null) {
        this._onChanges.forEach((cb) => {
            cb(type, data);
        });
    }
}
